<script>
export default {
  methods: {
    typeLabelShortFromBedsDen(beds, den) {
      let typeLabel = 'STUDIO';
      if (beds > 0) {
        typeLabel = `${beds.toString()} B`;
        if (den === 1) {
          typeLabel += '+D';
        }
      }
      return typeLabel;
    },
    typeLabelLongFromBedsDen(beds, den) {
      let typeLabel = 'studio';
      if (beds > 0) {
        typeLabel = `${beds.toString()} bedroom`;
        if (den === 1) {
          typeLabel += '+ den';
        }
      }
      return typeLabel;
    },
    exposureLabelBySlug(dir) {
      switch (dir) {
        case 'n': { return 'North'; }
        case 'e': { return 'East'; }
        case 's': { return 'South'; }
        case 'w': { return 'West'; }
        default: { return false; }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/mixins/FloorplansMixin.vue